import { Text } from "@mantine/core";
import clsx from "clsx";
import { getUserName, isArchived, isExpired } from "../helpers";

type UserInfoUser = {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  title?: string | null;
  archived?: string | null;
  endDate?: string | Date | null;
};

interface UserInfoProps {
  user: UserInfoUser;
}

const UserInfo: React.FC<UserInfoProps> = ({ user }) => {
  const isInactive = isArchived(user) || isExpired(user);
  const userName = getUserName(user);

  return (
    <div
      className={clsx(
        "max-w-full flex flex-col gap-y-1",
        isInactive && "text-gray!"
      )}
    >
      {userName && (
        <Text fz={"xs"} fw={500} lh={1}>
          {userName}
        </Text>
      )}

      {user?.title && (
        <Text
          c={"gray.7"}
          fz={"xs"}
          lh={1}
          className="break-all whitespace-normal"
        >
          {user.title}
        </Text>
      )}

      {user?.email && (
        <Text
          c={"gray.7"}
          fz={"xs"}
          lh={1}
          className="break-all whitespace-normal"
        >
          {user.email}
        </Text>
      )}
    </div>
  );
};

export default UserInfo;
